import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { QueryProvider } from "./providers/QueryProvider.tsx";

// Import real-time test utility (only in development)
if (import.meta.env.DEV) {
  import("./utils/testRealtime");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </StrictMode>
);
